import React from 'react';
import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import style from './timeStatusIndicator.module.scss';
import getTimeStatusColor from './utilis';
import ToolTip from '@/components/ToolTip/ToolTip';

function TimeStatusIndicator({
  value,
  displayTime = true,
  mode = 'elapsed',
  threshold = 1,
  alertOnExceed = true,
  toolTipText,
  icon = 'icon-reloj',
}) {
  const alert = getTimeStatusColor({
    value,
    mode,
    threshold,
    alertOnExceed,
  });

  return (
    <ToolTip minWidth="auto" title={toolTipText}>
      <Box
        className={`${style.timeStatusContainer} ${alert ? style.alert : ''}`}
      >
        <Icon icon={icon} fontSize="12px" />
        <Text>{displayTime}</Text>
      </Box>
    </ToolTip>
  );
}

export default TimeStatusIndicator;
